module.exports = __webpack_public_path__ + "img/1440.4ba30535.jpg";